/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (boostSDAppConfig) {
  boostSDAppConfig.searchSettings.suggestionBlocks[0].status = true;
  boostSDAppConfig.searchSettings.enableInstantSearch = true;
  boostSDAppConfig.searchSettings.suggestionMobileStyle = "style2";
}

function getValueByIdAndKey(data, searchId, searchKey) {
  for (var item of data) {
    if (item.id === searchId && item.key === searchKey) {
      try {
        const parsed = JSON.parse(item.value);
        if (parsed && parsed.amount) {
          return parseFloat(parsed.amount);
        }
      } catch (e) {
        return isNaN(item.value) ? item.value : parseFloat(item.value);
      }
    }
  }
  return null;
}

function hasMultipleUniquePrices(product) {
  var priceSet = new Set();
  product.variants.forEach((variant) => {
    priceSet.add(parseFloat(variant.price)); // Store unique prices
  });
  return priceSet.size > 1; // Returns true if multiple unique prices exist
}

function findLowestPriceVariant(product) {
  var lowestPrice = Infinity;
  var lowestPriceVariantId = null;
  product.variants.forEach((variant) => {
    var compareAtPrice = variant.compare_at_price ? parseFloat(variant.compare_at_price) : parseFloat(variant.price);
    if (compareAtPrice < lowestPrice) {
      lowestPrice = compareAtPrice;
      lowestPriceVariantId = variant.id;
    }
  });
  return { id: lowestPriceVariantId, price: lowestPrice };
}
// function findLowestPriceVariant(product) {
//   var lowestPrice = Infinity;
//   var lowestPriceVariantId = null;
//   product.variants.forEach((variant) => {
//     if (parseFloat(variant.price) < parseFloat(lowestPrice)) {
//       lowestPrice = variant.price;
//       lowestPriceVariantId = variant.id;
//     }
//   });
//   return { id: lowestPriceVariantId, price: lowestPrice };
// }


var customize = {
  updateProductItemISW: (componentRegistry) => {
    componentRegistry.useComponentPlugin("SearchProductItem", {
      name: "Customize product item ISW",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // --------------------------------------------Start customization--------------------------------------------
            var productData = element.getParams().props.product;
            var productMetafield = productData.metafields;
            var productId = productData.id;
            var showPercentOff = false;
            var enableCompareAtPrice = false;
            var checkVisitingCustomer = localStorage.getItem("setVisitingCustomer");
            var firstInStockVariant =
              productData.variants.find(
                (variant) => variant.inventory_quantity > 0
              ) || productData.variants[0];
            var compareAtPrice = firstInStockVariant?.compare_at_price ? firstInStockVariant?.compare_at_price : 0;
            var compareAtPriceMain = firstInStockVariant?.compare_at_price ? firstInStockVariant?.compare_at_price : 0;
            var salePrice = firstInStockVariant.price ? firstInStockVariant.price : 0;

            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            var productItem = document.querySelector('.boost-sd__suggestion-queries-item--product[data-id="' + productId + '"]');
            var dropdownFlairHtml = `<div class="badge-wdiget-from-flair" data-flair-product-badge data-product-id=${productId.toString()}></div>`;
            if (productItem && !productItem.querySelector(".badge-wdiget-from-flair")) {
              productItem.insertAdjacentHTML("beforeend", dropdownFlairHtml);
            }
            
            const tagToCheck = "hide-.25-.75-size-options";
            var linkElem = productItem.querySelector("a.boost-sd__suggestion-queries-item-link");
            if (linkElem) {
              var href = linkElem.getAttribute("href") || "";
              var cleanHref = href.replace(/\/collections\/[^/]+\/products\//, "/products/"); // Clean up the URL (remove /collections/.../products/)
              var updatedUrl = `${cleanHref}?variant=${firstInStockVariant.id}`; // Default updated URL
              
              if (productData.product_type === "Vow Engagement Rings") {
                updatedUrl = `${cleanHref}?variant=${firstInStockVariant.id}&diamondType=${firstInStockVariant.merged_options[0].replace("diamond_shape:", "").replace(/\s+/g, "")}&metal=${firstInStockVariant.merged_options[1].replace("metal:", "").replace(/\s+/g, "")}&startwithsetting=true`;
              }
              if (!productData.tags.includes(tagToCheck)) {
                linkElem.setAttribute("href", updatedUrl);
              }
            }

            // Refresh Flair Badges after search customization
            if (window.FlairApp?.refreshProductBadges) {
              FlairApp.refreshProductBadges();
            }
            // Check if the product has multiple unique prices
            var hasMultiplePrices = hasMultipleUniquePrices(productData);

            //---------------------------Custom Code---------------------------
            if (productItem) {
              var priceElement = productItem.querySelector(".boost-sd__suggestion-queries-item-price");
              if (priceElement) {
                var hasCompareClass = priceElement.querySelector(".boost-sd__format-currency--price-compare");
                var hasSaleClass = priceElement.querySelector(".boost-sd__format-currency--price-sale");
                var lowestPriceWithId = findLowestPriceVariant(productData);
                var price = parseFloat(firstInStockVariant.price);
                var variant_id = parseInt(firstInStockVariant.id);

                if (productData.price_max > productData.price_min) {
                  price = parseFloat(lowestPriceWithId.price);
                  variant_id = parseFloat(lowestPriceWithId.id);
                }

                if (!hasCompareClass && !hasSaleClass) {
                  priceElement.innerHTML = "";
                  var comparePriceSpan = document.createElement("span");
                  comparePriceSpan.classList.add(
                    "boost-sd__format-currency",
                    "boost-sd__format-currency--price-compare"
                  );
                  priceElement.appendChild(comparePriceSpan);
                  var newSpan = document.createElement("span");
                  var formattedPrice = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(price);
                  formattedPrice = formattedPrice.replace(".00", "");
                  newSpan.innerText = formattedPrice;
                  comparePriceSpan.appendChild(newSpan);

                  var salePriceSpan = document.createElement("span");
                  salePriceSpan.classList.add(
                    "boost-sd__format-currency",
                    "boost-sd__format-currency--price-sale"
                  );
                  priceElement.appendChild(salePriceSpan);
                  var newSaleSpan = document.createElement("span");
                  var formattedSalePrice = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(price);
                  formattedSalePrice = formattedSalePrice.replace(".00", "");
                  newSaleSpan.innerText = formattedSalePrice;
                  newSaleSpan.style.color = "black";
                  salePriceSpan.appendChild(newSaleSpan);
                }
              }
            }

            var targetCompare = productItem.querySelector(".boost-sd__format-currency.boost-sd__format-currency--price-compare");
            var targetSale = productItem.querySelector(".boost-sd__format-currency.boost-sd__format-currency--price-sale");
            /* Display the Sale Price for All Visitors. */
            if (showSalePriceGlobal && showSalePriceGlobal === true &&
              getValueByIdAndKey(productMetafield, variant_id, "custom_sale_price_currency") !== null) {
              compareAtPrice = price ? price : firstInStockVariant.price;
              salePrice = getValueByIdAndKey(productMetafield, variant_id, "custom_sale_price_currency")
                ? getValueByIdAndKey(productMetafield, variant_id, "custom_sale_price_currency")
                : 0;
              showPercentOff = true;
              enableCompareAtPrice = true;
            }
            /* Display the Sale Price for VIP Visitors. */
            if (showVIPPriceGlobal && showVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVIPParam &&
              getValueByIdAndKey(productMetafield, variant_id, "vip_price_sale_currency") !== null) {
              compareAtPrice = price ? price : firstInStockVariant.price;
              salePrice = getValueByIdAndKey(productMetafield, variant_id, "vip_price_sale_currency")
                ? getValueByIdAndKey(
                  productMetafield,
                  variant_id,
                  "vip_price_sale_currency")
                : 0;
              showPercentOff = true;
              enableCompareAtPrice = true;
            }
            /* Display the Sale Price exclusively for VVIP visitors. */
            if (showVVIPPriceGlobal && showVVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVVIPParam &&
              getValueByIdAndKey(productMetafield, variant_id, "vvip_price_sale_currency") !== null) {
              compareAtPrice = price ? price : firstInStockVariant.price;
              salePrice = getValueByIdAndKey(productMetafield, variant_id, "vvip_price_sale_currency")
                ? getValueByIdAndKey(
                  productMetafield,
                  variant_id,
                  "vvip_price_sale_currency")
                : 0;
              showPercentOff = true;
              enableCompareAtPrice = true;
            }
            
            /* Update the Compare At Price to reflect the First In-Stock Variant's Compare At Price. */
            var spanElement = targetCompare ? targetCompare.querySelector("span") : null;
            var parsedCompareAtPrice = parseFloat(compareAtPrice);
            var parsedCompareAtPriceMain = parseFloat(compareAtPriceMain);
            var parsedSalePrice = (parseFloat(salePrice) === 0) ? parseFloat(firstInStockVariant.price) : parseFloat(salePrice);
            var selectedCompareAtPrice = (hasMultiplePrices || parsedCompareAtPriceMain === 0) ? parsedCompareAtPrice : parsedCompareAtPriceMain;
            
            if (spanElement) {
              if (selectedCompareAtPrice > 0 && parsedSalePrice > 0 && selectedCompareAtPrice > parsedSalePrice) {
                var formattedPrice = new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(selectedCompareAtPrice).replace(".00", "");
                spanElement.classList.add("strikeThrough");
                spanElement.style.color = "black";
                spanElement.textContent = formattedPrice;
              } else {
                spanElement.textContent = "";
              }
            }

            /* Replace the Original Price with the First In-Stock Variant Price. */
            var saleSpanElement = targetSale ? targetSale.querySelector("span") : null;
            if (saleSpanElement && parseFloat(compareAtPrice) > 0 && parseFloat(salePrice) > 0 && parseFloat(compareAtPrice) > parseFloat(salePrice)) {
              var formattedSalePrice = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(parseFloat(salePrice));
              formattedSalePrice = formattedSalePrice.replace(".00", "");
              saleSpanElement.textContent = formattedSalePrice;
              saleSpanElement.style.setProperty(
                "color",
                spanElement ? salePriceColorGlobal : "black",
                "important"
              );
            }

            /* Swap the two spans to align with the Figma layout. */
            if (productData?.compare_at_price_min > 0) {
              var mainDiv = productItem.querySelector(".boost-sd__suggestion-queries-item-amount");
              mainDiv.insertBefore(targetCompare, targetSale);
            }

            /* If the Product Max Price exceeds the Product Min Price, prepend "Starting at" before the price. */
            if (productData.price_max - productData.price_min > 0 && targetCompare) {
              var span = document.createElement("span");
              span.classList.add("starting_at");
              span.style.color = "black";
              span.textContent = "Starting at";
              targetCompare.prepend(span);
            }
            
            /* Calculate the percentage based on the Compare Price vs. Regular Price or the Regular Price vs. Sale Price. */
            var parsedCompareAtPrice = parseFloat(compareAtPrice);
            var parsedCompareAtPriceMain = parseFloat(compareAtPriceMain);
            // var parsedSalePrice = parseFloat(salePrice);
            var selectedCompareAtPrice = (hasMultiplePrices || parsedCompareAtPriceMain === 0) ? parsedCompareAtPrice : parsedCompareAtPriceMain;
            /* Show percent off in compare at price */
            showPercentOff = true;
            
            // if (showPercentOff && targetCompare && selectedCompareAtPrice > parsedSalePrice && parsedSalePrice > 0) {
            // if (showPercentOff && targetCompare && selectedCompareAtPrice > 0 && parsedSalePrice > 0 && selectedCompareAtPrice > parsedSalePrice) {
            if (showPercentOff && targetCompare && selectedCompareAtPrice > 0 && selectedCompareAtPrice > parsedSalePrice) {
              var discountRaw = ((selectedCompareAtPrice - parsedSalePrice) / selectedCompareAtPrice) * 100;
              var discountPercentage = Math.round(discountRaw * 100) % 100 === 0 ? discountRaw.toFixed(0) : discountRaw.toFixed(2);
              var span = document.createElement("span");
              span.classList.add("percent_off");
              span.style.color = salePriceColorGlobal;
              span.textContent = discountPercentage + "% Off";
              targetCompare.insertAdjacentElement("afterend", span);
            }

            /* Add the 'break' class to position the last two spans on a new line in the UI, in accordance with the Figma design. */
            var targetStarting = productItem.querySelector(".starting_at");
            var targetPercent = productItem.querySelector(".percent_off");
            if (targetSale && targetCompare && targetStarting && targetPercent) {
              if (targetCompare && targetSale.length !== 0 && targetCompare.length !== 0 && targetStarting.length !== 0 && targetPercent.length !== 0) {
                targetCompare.classList.add("break");
              }
            }
            // -------------------------------------------------------------End-------------------------------------------------------------
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
  searchInputProps: (componentRegistry) => {
    componentRegistry.useComponentPlugin("SearchInput", {
      name: "Customize click suggestion Result keep open ISW",
      enabled: true,
      apply: () => ({
        props(props) {
          props.hasSearchModal = false;
          return props;
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
  (registry) => {
    registry.useModulePlugin("SearchAPI", {
      name: "Extra data SearchAPI",
      apply(builder) {
        builder.on("methodFulfilled", "get", (res) => {
          if (
            (res.result.suggestions?.length === 0 || !res.result.suggestions) &&
            res.result.collections?.length === 0 &&
            res.result.products?.length === 0
          ) {
            res.result.pages = [];
            res.result.all_empty = true;
          }
        });
      },
    });
  }
);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.updateProductItemISW,
  customize.searchInputProps,
]);

if (boostSDAppConfig?.searchSettings && boostSDAppConfig?.searchSettings) {
  boostSDAppConfig.searchSettings.suggestionBlocks = [
    { type: "suggestions", label: "Suggestions", status: "active", number: 3 },
    { type: "collections", label: "Collections", status: "active", number: 2 },
    { type: "pages", label: "Pages", status: "false", number: 2 },
    { type: "products", label: "Products", status: "active", number: 4 },
  ];
  boostSDAppConfig.searchSettings.showSuggestionProductSalePrice = true;
}

// Fix ISW Conflict Events
window.addEventListener("keydown", function (event) {
  if (event.target.className.includes('Search__Input')) {
    event.target.click();
  }
});